import React from 'react';
import styled from "styled-components";
import PropTypes from "prop-types";
import {ESCAPE} from '../constants/keys'

import ProductSize from './ProductSize';

const ModalRit = styled.div`
    border-radius: 4px;
    box-shadow: -2px 2px 10px 0 rgba(102, 116, 166, 0.2);
    background-color: #fff;
    color: #444;
    width: 50%;
    max-width: 590px;
    min-width: 355px;

    display: flex;
    height: auto;
    margin: 30px 0 70px;

    @media (max-width: 768px) {
        background: #f1f1f1;
        min-width: 150px;
        width: 100%;
        margin: 15px;
    }
`

const Backdrop = styled.div`
    position: fixed;
    top: 68px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    background-color: rgba(255, 255, 255, 0.80);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: auto;

    &::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: 768px) {
        top: 58px;
        margin-top: 0;
    }
`

export default class SizeMediaModal extends React.Component {
    constructor(){
        super();
        this.state = {}
    }

    componentDidMount() {
        if (this.props.closeOnEsc) {
            window.addEventListener('keydown', this.onKeyDownClose)
        }
    }

    componentWillUnmount() {
        if (this.props.closeOnEsc) {
            window.removeEventListener('keydown', this.onKeyDownClose)
        }
    }

    onKeyDownClose = event => {
        if (event.keyCode === ESCAPE) this.props.toggle()
    }

    render() {
        const { onClose, toggle } = this.props;

        return (
            <React.Fragment>
                <Backdrop onClick={onClose}>
                    <ModalRit>
                        <ProductSize toggle={toggle}/>
                    </ModalRit>
                </Backdrop>
            </React.Fragment>
        )
    }
}

SizeMediaModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
    closeOnEsc: PropTypes.bool.isRequired,
};
